import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authentication/authContext';
import { canAccessSuperAdminDashboard } from '../services/accessManagement/accessManagement';

export function SuperAdminRoute({ children }: { children: JSX.Element }) {
  const { user, backendUser, loading } = useAuth();

  // Wait for both auth loading AND backendUser to be available
  if (loading || (user && !backendUser)) {
    return <div className="p-6">Loading...</div>;
  }

  // Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but not a super admin
  if (!backendUser || !canAccessSuperAdminDashboard(backendUser)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
